// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iH4jDpNwM0cFic {
  display: flex;
  flex-wrap: wrap;
}
.PcYiiipkPay5E4 {
  flex: 1 1 100%;
  margin-bottom: 8px;
}
.A4nQqN9xxDMDKr {
  flex: 2.5;
  margin-right: 8px;
  margin-bottom: 8px;
}
.zJIpFPMiTfbd88 {
  flex: 1;
  margin-bottom: 8px;
}
.TSXdP213jT5zoY {
  border-radius: 3px;
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: dP1_HXQPQChSjH;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  width: 60px;
  height: 20px;
  margin-top: 4px;
  margin-bottom: 2px;
}
@keyframes dP1_HXQPQChSjH {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .TSXdP213jT5zoY {
    animation: none;
  }
}
.EVS7Czvakfjot3 {
  border-radius: 3px;
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: dP1_HXQPQChSjH;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  height: 36px;
}
@keyframes dP1_HXQPQChSjH {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .EVS7Czvakfjot3 {
    animation: none;
  }
}
.v2_DrjjODwqrbS {
  border-radius: 3px;
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: dP1_HXQPQChSjH;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  width: 26px;
  height: 20px;
  margin-top: 8px;
  padding: 6px 24px;
}
@keyframes dP1_HXQPQChSjH {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .v2_DrjjODwqrbS {
    animation: none;
  }
}
.Gk1h2PtDNjstWk {
  border-radius: 3px;
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: dP1_HXQPQChSjH;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  width: 120px;
  height: 16px;
  margin-top: 16px;
  margin-bottom: 8px;
}
@keyframes dP1_HXQPQChSjH {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .Gk1h2PtDNjstWk {
    animation: none;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"skeletonSelectContainer": `iH4jDpNwM0cFic`,
	"skeletonBoardContainer": `PcYiiipkPay5E4`,
	"skeletonListContainer": `A4nQqN9xxDMDKr`,
	"skeletonPositionContainer": `zJIpFPMiTfbd88`,
	"skeletonSelectLabel": `TSXdP213jT5zoY`,
	"shimmer": `dP1_HXQPQChSjH`,
	"skeletonSelectBox": `EVS7Czvakfjot3`,
	"skeletonButton": `v2_DrjjODwqrbS`,
	"skeletonHeaderText": `Gk1h2PtDNjstWk`
};
export default ___CSS_LOADER_EXPORT___;
